import { render, staticRenderFns } from "./pesquisa.vue?vue&type=template&id=1b0ebe84&"
import script from "./pesquisa.vue?vue&type=script&lang=js&"
export * from "./pesquisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports